import type * as Types from '../../types';

import gql from 'graphql-tag';
import type * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/client';
export type MoodleSyncCalendarEventsMutationVariables = Types.Exact<{
  moodleCourseId: Types.Scalars['Int'];
}>;


export type MoodleSyncCalendarEventsMutation = { moodleSync?: Types.Maybe<{ __typename?: 'MoodleSyncResult', status: boolean, statusCode?: Types.Maybe<string>, statusMessage?: Types.Maybe<string> }> };


export const MoodleSyncCalendarEventsDocument = gql`
    mutation moodleSyncCalendarEvents($moodleCourseId: Int!) {
  moodleSync: moodleSyncCalendarEvents(moodleCourseId: $moodleCourseId) {
    status
    statusCode
    statusMessage
  }
}
    `;
export type MoodleSyncCalendarEventsMutationFn = ApolloReactCommon.MutationFunction<MoodleSyncCalendarEventsMutation, MoodleSyncCalendarEventsMutationVariables>;

/**
 * __useMoodleSyncCalendarEventsMutation__
 *
 * To run a mutation, you first call `useMoodleSyncCalendarEventsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoodleSyncCalendarEventsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moodleSyncCalendarEventsMutation, { data, loading, error }] = useMoodleSyncCalendarEventsMutation({
 *   variables: {
 *      moodleCourseId: // value for 'moodleCourseId'
 *   },
 * });
 */
export function useMoodleSyncCalendarEventsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MoodleSyncCalendarEventsMutation, MoodleSyncCalendarEventsMutationVariables>) {
        return ApolloReactHooks.useMutation<MoodleSyncCalendarEventsMutation, MoodleSyncCalendarEventsMutationVariables>(MoodleSyncCalendarEventsDocument, baseOptions);
      }
export type MoodleSyncCalendarEventsMutationHookResult = ReturnType<typeof useMoodleSyncCalendarEventsMutation>;
export type MoodleSyncCalendarEventsMutationResult = ApolloReactCommon.MutationResult<MoodleSyncCalendarEventsMutation>;
export type MoodleSyncCalendarEventsMutationOptions = ApolloReactCommon.BaseMutationOptions<MoodleSyncCalendarEventsMutation, MoodleSyncCalendarEventsMutationVariables>;
export type PartialResultType<T> = Types.PartialResultType<T>;
export type ResultType<T> = Types.ResultType<T>;
export type NonMaybe<T> = Types.NonMaybe<T>;
